import ModalContentWrapper from "root/Modals/ModalContentWrapper";
import './ModalLoadSimsTeacher.scss';
import {manuallyAssignAsTeacherForWonde} from "root/DataFunctions/SIMSManagerFns";
import React, {Fragment, useState} from "react";
import {SIMS_IS_TEACHER, translateIsTeacher} from "root/s360components/Tables/TeacherLoadTable";
import {ModalLoadSimsTeacherModes} from "root/s360components/Modals/TeacherLoader/useModalLoadSimsTeacher";
import {ModalButton} from "root/Modals/ModalLearningJournal/commonExports";

const ModalLoadSimsTeacher = ({mode, enc_school_id, teacher, onClose, onSaveComplete}) =>
{
    const empty = <i>N/A</i>;

    const registration_class = teacher?.registration_class === null || teacher?.registration_class === undefined ? empty : teacher.registration_class;

    const mis_id = teacher?.mis_id === null || teacher?.mis_id === undefined ? empty : teacher.mis_id;

    const [ disableButtons, setDisableButtons ] = useState ( false ) ;

    const [ modalMode, setModalMode ] = useState ( mode ) ;

    const onConfirm = () =>
    {
        setDisableButtons( true ) ;

        const data = {sims_line_id: teacher.sims_line_id, status: SIMS_IS_TEACHER }

        manuallyAssignAsTeacherForWonde(enc_school_id, data, (response) =>
        {
            setDisableButtons(false) ;
            setModalMode ( ModalLoadSimsTeacherModes.CONFIRM ) ;
        })
    }

    const onDone = () =>
    {
        onSaveComplete('saved') ;
    }

    const loadSection = () =>
    {
        return (
            <Fragment>
                <h2 style={{textAlign: "center"}}>Are you sure you want to load this teacher?</h2>
                <div className='teacher-details'>
                    <p><strong>Name: </strong>{teacher.firstname + ' ' + teacher.surname}</p>
                    <p><strong>Reg class: </strong>{registration_class}</p>
                    <p><strong>Teacher number: </strong>{teacher.teacher_number}</p>
                    <p><strong>Wonde ID: </strong>{teacher.wonde_id}</p>
                    <p><strong>MIS ID: </strong>{mis_id}</p>
                    <p><strong>Current teacher staus: </strong>{translateIsTeacher(teacher.is_teacher)}</p>
                </div>
                <div className='modal-sims-load-buttons'>
                    <ModalButton onClick={() => onClose()} text='Cancel' additionalClass='btn-gray' disabled={disableButtons} />
                    <ModalButton onClick={() => onConfirm(enc_school_id, teacher)} text='Confirm' additionalClass='btn-success' disabled={disableButtons}/>
                </div>
            </Fragment>
        )
    }

    const doneSection = () =>
    {
        return (
            <div className='sims-load-returned-message'>
                This teacher was successfully loaded into the school360 database.
                <div className='modal-sims-load-buttons'>
                    <button type='button' className='btn btn-success' onClick={onDone}>OK</button>
                </div>
            </div>
        )
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            {(mode === ModalLoadSimsTeacherModes.LOAD && modalMode === ModalLoadSimsTeacherModes.LOAD ) && loadSection()}
            {(mode === ModalLoadSimsTeacherModes.LOAD && modalMode === ModalLoadSimsTeacherModes.CONFIRM) && doneSection()}
            {mode === ModalLoadSimsTeacherModes.NONE && <div />}
        </ModalContentWrapper>
    )
}

export default ModalLoadSimsTeacher;